import { useSelector } from 'react-redux';

const EMPTY_OBJECT = {};
/**
 * Returns the redux state for seo data
 * @name useSEO
 * @returns {cartInfo}
 */
export default function useSEO() {
    const seo = useSelector(state => state.slugInfo.seo || EMPTY_OBJECT);
    return seo;
}
